export default __webpack_public_path__ + "static/media/336.9410dfb4.jpg";